<template>
  <div class="expansion-panels">
    <template v-for="(item, index) in items" >
      <ExpansionPanel
        :key="index"
        :header="item.header"
        :content="item.content"
        :divider="index < items.length - 1"
        @toggleExpander="onToggleExpander"
      />
    </template>
  </div>
</template>

<script>
import ExpansionPanel from './ExpansionPanel'

export default {
  name: 'ExpansionPanels',
  components: {
    ExpansionPanel
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup (props, context) {
    function onToggleExpander(isExpanded) {
      context.emit('toggleExpander', isExpanded)
    }
    return {
      onToggleExpander
    }
  }
}
</script>

<style scoped lang="postcss">
</style>
